import React, {
  ChangeEvent,
  CSSProperties,
  forwardRef,
  KeyboardEvent,
  useEffect,
  useImperativeHandle,
  useRef,
} from "react";

type AutoResizeTextAreaProps = {
  className?: string;
  style?: CSSProperties;
  "data-testid"?: string;
  disabled?: boolean;
  placeholder?: string;
  rows?: number;
  value: string;
  onChange: (value: string) => void;
  onKeyDown?: (e: KeyboardEvent<HTMLTextAreaElement>) => void;
};

const AutoResizeTextArea = forwardRef<HTMLTextAreaElement | null, AutoResizeTextAreaProps>(
  (props, ref) => {
    const internalRef = useRef<HTMLTextAreaElement | null>(null);

    useImperativeHandle(ref, () => internalRef.current);

    useEffect(() => {
      const textarea = internalRef.current;

      if (textarea) {
        // รีเซ็ตความสูงก่อน เพื่อคำนวณความสูงที่ต้องการใหม่
        textarea.style.height = "auto";
        // ตั้งค่าความสูงตาม scrollHeight
        textarea.style.height = `${textarea.scrollHeight}px`;
      }
    }, [props.value]);

    const handleChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
      props.onChange(e.target.value);
    };

    return (
      <textarea
        ref={internalRef}
        className={props.className}
        style={props.style}
        data-testid={props["data-testid"]}
        disabled={props.disabled}
        placeholder={props.placeholder}
        rows={props.rows}
        value={props.value}
        onChange={handleChange}
        onKeyDown={props.onKeyDown}
      />
    );
  }
);

AutoResizeTextArea.displayName = "AutoResizeTextArea";

export default React.memo(AutoResizeTextArea);
